package com.karawek.core.ui.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography

/**
 * Confirmation dialog (often destructive).
 *
 * Explicit semantic separation from alert dialogs.
 */
@Composable
fun CoreConfirmDialog(
    title: String,
    message: String,
    confirmText: String,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
    extraContent: (@Composable () -> Unit)? = null,
) {
    AlertDialog(
        containerColor = CoreTheme.colors.background,
        iconContentColor = CoreTheme.colors.onBackgroundStrong,
        titleContentColor = CoreTheme.colors.onBackgroundStrong,
        textContentColor = CoreTheme.colors.onBackground,
        onDismissRequest = onDismiss,
        title = {
            Text(
                text = title,
                style = CoreTypography.title,
            )
        },
        text = {
            Column {
                Text(
                    text = message,
                    style = CoreTypography.bodySecondary,
                )
                if (extraContent != null) {
                    Spacer(modifier = androidx.compose.ui.Modifier.height(CoreSpacing.md))
                    extraContent()
                }
            }
        },
        confirmButton = {
            CorePrimaryButton(
                text = confirmText,
                onClick = onConfirm,
            )
        },
        dismissButton = {
            CoreSecondaryButton(
                text = "Cancel",
                onClick = onDismiss,
            )
        },
    )
}
